import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import { inlineLexer } from 'marked'
import { injectIntl } from 'react-intl'
import { findLocalized } from '../utils'

const DiventaSponsor = ({ intl: { locale } }) => (
  <StaticQuery
    query={graphql`
      query { 
        allDiventaSponsorYaml{
          edges{
            node{
              title
              text
              lang
            }
          }
        }   
      }
    `}
    render={data => {
      const { title, text } = findLocalized(data.allDiventaSponsorYaml, locale);
      return (
        <>
          <span id="diventa-sponsor" className="section__anchor"></span>
          <section className="section diventa-sponsor text-center" aria-labelledby="region-diventa-sponsor">
            <div className="container">
              <div className="row" data-aos="fade-up">
                <div className="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                  <h1 id="region-diventa-sponsor" className="section__title">{title}</h1>
                  <p dangerouslySetInnerHTML={{__html: inlineLexer(text, [])}}></p>
                </div>
              </div>
            </div>
          </section>
        </>
      )
    }}
  />
);

export default injectIntl(DiventaSponsor);
